import { Injectable } from '@angular/core';
import { Feature, GeoJsonProperties, Geometry } from 'geojson';

@Injectable()
export class GeoJsonTransformerService {
  transformPostsToGeoJson(posts: any[]): any[] {
    return posts.map((r) => ({
      type: r.geojson?.type,
      features:
        r.geojson?.features.map((f: Feature<Geometry, GeoJsonProperties>) => {
          f.properties = {
            data_source_message_id: r.data_source_message_id,
            description: r.description,
            id: r.id,
            'marker-color': r['marker-color'],
            map_marker_config: JSON.parse(r.map_marker_config),
            source: r.source,
            title: r.title,
            time_reference: {
              created: new Date(r.created * 1000),
              updated: new Date(r.updated * 1000),
              approved: new Date(r.approved * 1000),
            },
          };
          return f;
        }) ?? [],
    }));
  }
}
